exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__label___2aZtM:not(:nth-child(1)) {\n  margin-top: 21px; }\n\n.style__disabledSelect___1ZbKz div div div {\n  color: #ccc !important; }\n", ""]);

// exports
exports.locals = {
	"label": "style__label___2aZtM",
	"disabledSelect": "style__disabledSelect___1ZbKz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/RegistrationSelect/style.scss
// module id = 1678
// module chunks = 6